import type { GetServerSidePropsContext } from "next/types";

import Bugsnag from "@bugsnag/js";

import DiscussionsPageLayout from "components/DiscussionsPageLayout";
import DiscussionPageBrowse, {
  discussionsUrl as getDiscussionsUrl,
} from "components/DiscussionsPageLayout/DiscussionPageBrowse";
import type { NextPageWithLayout } from "pages/_app";
import {
  authenticatedAccountUrl,
  sessionFromContextCookie,
} from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const DiscussionsPage: NextPageWithLayout = () => {
  return <DiscussionPageBrowse />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const tab = context.query.tab as string;
    const discussionsUrl = getDiscussionsUrl(1, tab, {
      excludeBots: false,
    });

    const session = sessionFromContextCookie(context);
    const accountUrl = authenticatedAccountUrl(
      session?.authenticated?.account_id
    );

    const [discussions, account] = await Promise.all([
      isSsr(context)
        ? baseFetcher(discussionsUrl, context)
        : Promise.resolve(null),
      isSsr(context) && accountUrl
        ? baseFetcher(accountUrl, context)
        : Promise.resolve(null),
    ]);

    return {
      props: {
        fallback: {
          [`$inf$${discussionsUrl}`]: [discussions],
          [accountUrl]: account,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps discussions Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

DiscussionsPage.getLayout = (page, { pageProps }) => {
  return <DiscussionsPageLayout {...pageProps}>{page}</DiscussionsPageLayout>;
};

export default DiscussionsPage;
